import api from '@/apis/ca/cAReceiptAPI.js';
import Crud from '@/stores/crudBase';
import EventBusGlobal from '@/commons/eventBusGlobal';

var crud = new Crud('cAReceipt', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ca_receipt',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Cập nhật bản ghi mới ra màn danh sách sau khi sinh
   * NTLOC 26.10.2022
   */
  async insertVoucherEmis(context, payload) {
    context.commit('insertListItem', payload);
  },
};
const mutations = {
  ...crud.mutations,
  /**
   * Ghi đè Cập nhật khi sửa bản ghi ghi sổ
   * lttuan1 9.8.2022
   */
  updateItemPosted(state, payload) {
    // refresh lại bảng BAWithDraw
    EventBusGlobal.$emit('BAWithDraw/refresh');
    // thực thi hàm của base
    crud.mutations.updateItemPosted(state, payload);
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
